import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import CompraIcon from "../../assets/icons/produtos.png";

import ComprasService from "../../services/ComprasService";
import ProdutosService from "../../services/ProdutosService";
import FornecedoresService from "../../services/FornecedoresService";
import FormaPagtoService from "../../services/FormaPagtoService";

import formCompraDTO from "../../types/FormCompraDTO";

export default function ComprasForm({
  itemSelecionado,
  modo,
  onClose
}) {
  const { setRetorno } = useGerenciamento();

  const [form, setForm] = useState({
    idCompra: null,
    dataCompra: "",
    idFornecedor: "",
    idPagto: "",
    parcelada: false,
    pago: false,
    dataVencimento: "",
    dataPagamento: "",
    observacoes: ""
  });

  const [itens, setItens] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [fornecedores, setFornecedores] = useState([]);
  const [formasPagto, setFormasPagto] = useState([]);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // ==========================
  // LOAD BASE
  // ==========================
  useEffect(() => {
    async function carregarDados() {
      const [f, p, fp] = await Promise.all([
        FornecedoresService.getAtivos(),
        ProdutosService.getAtivos(),
        FormaPagtoService.getAtivos()
      ]);

      setFornecedores(f || []);
      setProdutos(p || []);
      setFormasPagto(fp || []);
    }

    carregarDados();
  }, []);

  // ==========================
  // LOAD ALTERAR
  // ==========================
// ==========================
// LOAD ALTERAR
// ==========================
  useEffect(() => {
    if (modo === "alterar" && itemSelecionado) {

      setForm({
        idCompra: itemSelecionado.IDCOMPRA,
        dataCompra: itemSelecionado.DATA_COMPRA,
        idFornecedor: itemSelecionado.IDFORNECEDOR,
        idPagto: itemSelecionado.IDPAGTO,
        parcelada: Boolean(itemSelecionado.PARCELADA),
        pago: Boolean(itemSelecionado.PAGO),
        dataVencimento: itemSelecionado.DATA_VENCIMENTO,
        dataPagamento: itemSelecionado.DATA_PAGAMENTO,
        cancelada: Boolean(itemSelecionado.CANCELADA),
        observacoes: itemSelecionado.OBSERVACOES ?? ""
      });

      setItens(
        (itemSelecionado.itens || []).map(item => ({
          idProduto: item.IDPRODUTO,
          quantidade: item.QUANTIDADE,
          valorUnitario: item.valorunitario,
          valorTotal: item.valortotal
        }))
      );
    }
  }, [modo, itemSelecionado]);

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value } = e.target;

    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  }

  function handleItemChange(index, campo, valor) {
    const novos = [...itens];

    novos[index][campo] = valor;

    const qtd = Number(novos[index].quantidade || 0);
    const valorUnit = Number(novos[index].valorUnitario || 0);

    novos[index].valorTotal = qtd * valorUnit;

    setItens(novos);
  }

  function adicionarItem() {
    setItens([
      ...itens,
      {
        idProduto: "",
        quantidade: 1,
        valorUnitario: 0,
        valorTotal: 0
      }
    ]);
  }

  function removerItem(index) {
    setItens(itens.filter((_, i) => i !== index));
  }

  // ==========================
  // VALIDAR
  // ==========================
  function validar() {
    const e = {};

    if (!form.idFornecedor) e.idFornecedor = "Informe fornecedor";
    if (!form.idPagto) e.idPagto = "Informe Forma de pagamento";
    if (!form.dataCompra) e.dataCompra = "Informe data";
    if (!itens.length) e.itens = "Adicione itens";

    return e;
  }

  // ==========================
  // TOTAL
  // ==========================
  const valorTotal = itens.reduce(
    (t, i) => t + Number(i.valorTotal || 0),
    0
  );

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validar();
    setErrors(validation);

    if (Object.keys(validation).length) return;

    setLoading(true);

    try {
      if (modo === "novo") {
          const payload = formCompraDTO({
                dataCompra: form.dataCompra,
                idFornecedor: Number(form.idFornecedor),
                valorTotal: Number(valorTotal),
                idPagto: Number(form.idPagto),
                parcelada: form.parcelada,
                pago: form.pago,
                cancelada: form.cancelada,
                dataVencimento: form.dataVencimento,
                dataPagamento: form.dataPagamento,
                observacoes: form.observacoes,
                  itens: itens.map(i => ({
                  idProduto: Number(i.idProduto),
                  quantidade: Number(i.quantidade),
                  valorUnitario: Number(i.valorUnitario),
                  valorTotal: Number(i.valorTotal)
                }))
          });

        await ComprasService.create(payload);

        console.log("Payload Front", payload);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Compra criada com sucesso!"
        });
      }

      if (modo === "alterar") {

        await ComprasService.update(
          form.idCompra,
          {
            pago: form.pago,
            cancelada: form.cancelada
          }
        );

        setRetorno({
          tipo: "sucesso",
          mensagem: "Compra atualizada com sucesso!"
        });
      }

      onClose();
    } catch {
      onClose();
      setRetorno({
        tipo: "erro",
        mensagem: "Erro ao salvar compra."
      });

      onClose();
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={CompraIcon} alt="" className="icon" />
          {modo === "novo" ? "Nova Compra" : "Alterar Compra"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Fornecedor *</div>
          <select
            name="idFornecedor"
            value={form.idFornecedor}
            disabled={modo === "alterar"}
            onChange={handleChange}
          >
            <option value="">Selecione</option>

            {fornecedores.map(f => (
              <option key={f.IDFORNECEDOR} value={f.IDFORNECEDOR}>
                {f.RAZAO_SOCIAL || f.NOME_FANTASIA}
              </option>
            ))}
          </select>
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Data Compra *</div>
          <input
            type="date"
            name="dataCompra"
            disabled={modo === "alterar"}
            value={form.dataCompra}
            onChange={handleChange}
          />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Forma Pagamento</div>
          <select
            name="idPagto"
            value={form.idPagto}
            disabled={modo === "alterar"}
            onChange={handleChange}
          >
            <option value="">Selecione</option>
            {formasPagto.map(p => (
              <option key={p.IDPAGTO} value={p.IDPAGTO}>
                {p.descricao}
              </option>
            ))}
          </select>
        </div>
      
        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-label">Itens da venda</div><br/>

        <div className="label-itens">
          <div className="select-itens">Descrição </div> |
          <div className="input-itens">Qtde. </div> |
          <div className="input-itens">Vr. Un.</div> |
          <div className="input-itens">Vr. Tot.</div> 
        </div>

        {itens.map((item, index) => (
          <div key={index} className="Form-Interno-alinhamento-itens">
            <select
              className="select-itens"
              value={item.idProduto}
              disabled={modo === "alterar"}
              onChange={e =>
                handleItemChange(index, "idProduto", e.target.value)
              }
            >
              <option value="" className="select-itens">Produto</option>
              {produtos.map(p => (
                <option key={p.IDPRODUTO} value={p.IDPRODUTO}>
                  {p.DESCRICAO}
                </option>
              ))}
            </select>

            <input
              type="number"
              className="input-itens"
              value={item.quantidade}
              onChange={e =>
                handleItemChange(index, "quantidade", e.target.value)
              }
              placeholder="Qtd"
            />

            <input
              type="number"
              step="0.01"
              className="input-itens"
              value={item.valorUnitario}
              onChange={e =>
                handleItemChange(index, "valorUnitario", e.target.value)
              }
              placeholder="Valor"
            />

            <input className="input-itens" value={item.valorTotal} disabled />

            <button type="button" title="remover item" onClick={() => removerItem(index)}>
              X
            </button>
          </div>
        ))}

        {modo ==="novo" && (
        <div className="Form-Interno-alinhamento-button">
          <button type="button" onClick={adicionarItem}>
            + Item
          </button>
        </div>
        )}
        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label" value={valorTotal}>
            Total: R$ {valorTotal.toFixed(2)}
          </div>
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Observações</div>
          <textarea
            name="observacoes"
            value={form.observacoes}
            onChange={handleChange}
          />
        </div>

        <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Status:</div>
            <select name="pago" value={String(form.pago)} onChange={handleChange}>
              <option selected value="">Selecione</option>
              <option value={true}>Pago</option>
              <option value={false}>Pendente</option>
            </select>
        </div>

          {modo ==="alterar" && (
            <>
              <div className="Form-Interno-alinhamento">
                <div className="Form-Interno-label">Cancelar Compra:</div>
                <select name="cancelada" value={String(form.cancelada)} onChange={handleChange}>
                  <option selected value="">Selecione</option>
                  <option value={true}>Sim</option>
                  <option value={false}>Não</option>
                </select>
              </div>
            </>
          )}

        <div className="Form-Interno-alinhamento-button">
          <button type="submit" disabled={loading} className="Form-Interno-button">
            {loading ? "Salvando..." : "Salvar"}
          </button>

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}